import { render, staticRenderFns } from "./EditorUploads.vue?vue&type=template&id=4ed495e8&"
import script from "./EditorUploads.vue?vue&type=script&lang=js&"
export * from "./EditorUploads.vue?vue&type=script&lang=js&"
import style0 from "./EditorUploads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports